import { createFileRoute } from '@tanstack/react-router'

import { DocumentTypes } from '@/widgets/document-types'

export const Route = createFileRoute('/_app/settings/document-types')({
  component: RouteComponent,
})

export const DocumentTypesRoute = Route

function RouteComponent() {
  return <DocumentTypes />
}
